// The generated OpenAPI document (`SC-F201`, `SC-F202`): `GET /v1/openapi.json`.
//
// This module reads the document and counts it. It deliberately does NOT model
// it: the types below stop at the two facts the reference page states beside the
// viewer — how many paths and how many operations the deployment declares — and
// everything else is passed to the viewer as an opaque object. Typing the whole of
// OpenAPI 3.0.3 here would be a second, hand-maintained description of a document
// whose entire purpose is to be the generated one, and every upstream field
// addition would break a type nothing reads.
//
// **The call is anonymous**, like `api/status.ts` and for a related reason:
// `06` §3.1 serves the document to anyone, `internal/apidoc` registers it with no
// auth, and attaching a stale stored token would produce a `401` that has nothing
// to do with the request. It also means the reference is readable during a
// sign-in outage, which is when a developer is most likely to be checking what a
// route is supposed to answer.

import { getJSON } from "./http.js";

/**
 * OpenAPIDocument is the document as far as this client cares.
 *
 * `paths` is an index whose VALUES are left opaque on purpose — see the module
 * comment. The viewer consumes the whole object; this shape exists so the page
 * can count what it is showing without pretending to understand it.
 */
export interface OpenAPIDocument {
  openapi?: string;
  info?: {
    title?: string;
    version?: string;
    description?: string;
  };
  /** One entry per path, keyed by the path template. The value is a path item
   * whose keys are HTTP methods; [countOperations] is the only thing that looks
   * inside one. */
  paths?: Record<string, Record<string, unknown>>;
}

/**
 * The HTTP methods an OpenAPI path item may carry, lowercased as the
 * specification spells them.
 *
 * The list is closed because a path item also carries non-operation keys —
 * `parameters`, `summary`, `description`, `servers`, `$ref` — and counting those
 * as operations would inflate the number the reference page shows. `internal/apidoc`
 * emits only `get`/`post`/`put`/`patch`/`delete` today; the other three are here
 * because the specification allows them and a count that silently ignored a
 * `head` would be wrong rather than conservative.
 */
const OPERATION_METHODS = [
  "get",
  "put",
  "post",
  "delete",
  "options",
  "head",
  "patch",
  "trace",
] as const;

/**
 * fetchOpenAPI reads the document. It throws the typed `ApiError` on failure like
 * every other call in `api/`, so the reference page has one failure path and can
 * quote the `request_id`.
 */
export function fetchOpenAPI(): Promise<OpenAPIDocument> {
  return getJSON<OpenAPIDocument>("/v1/openapi.json", { anonymous: true });
}

/**
 * countOperations counts the METHOD-plus-path pairs the document declares.
 *
 * It is separate from the path count because the two answer different questions
 * and a reader needs both: 98 paths and 125 operations means a third of the
 * surface carries more than one verb, which is what tells them whether the list
 * they are scrolling is the whole API. Non-operation keys on a path item are
 * skipped — see [OPERATION_METHODS].
 */
export function countOperations(doc: OpenAPIDocument): number {
  let n = 0;
  for (const item of Object.values(doc.paths ?? {})) {
    if (item === null || typeof item !== "object") continue;
    for (const method of OPERATION_METHODS) {
      if (method in item) n += 1;
    }
  }
  return n;
}
